
    import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    import moment from 'moment';

    import commentServices from '@/services/comment-services';
    import fileUploadServices from '@/services/file-upload-services';
    import { Comment } from '@/models/comment';
    import { APP_CONFIG } from '@/config/app-config'
    @Component
    export default class ChatBox extends Vue {
        @Prop({default: 0})
        private orderId!: number;

        @Prop({default: 1})
        private orderType!: number;

        private comment: string = '';
        private listComment: Comment[] = [];
        private timer: any;

        private isBlockEnter = false;
        private isUploading = false;

        get userInfo() {
            return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
        }

        private async created() {
            this.timer = setInterval(() => {
                this.loadComment();
            }, APP_CONFIG.notifyRefreshTime * 1000);
        }

        private async destroyed() {
            clearInterval(this.timer);
        }

        @Watch('orderId', { immediate: true, deep: true })
        private async loadComment() {
            if (this.orderId > 0) {
                const result: any = await commentServices.getComment(this.orderId, this.orderType);
                if(result && result.data.status === 200 && result.data.message === 'Success') {
                    const arrComment: any = [];
                    for (const item of result.data.data) {
                        arrComment.push({
                            ...item,
                            CreatedDate: moment(item.CreatedDate).format('DD-MM-YYYY hh:mm:ss')
                        });
                    }

                    this.listComment = arrComment;
                }
                this.setScroll();
            }
        }

        private onCommentKeyup(e: any) {
            if(e.keyCode === 13) {
                e.preventDefault();
                this.addComment();
            }
        }
        
        private async addComment() {
            if (this.comment.trim().length > 0 && this.isBlockEnter === false) {
                this.isBlockEnter = true;
                const commentModel: Comment = {
                    OrderID: this.orderId,
                    Comment: this.comment,
                    Status: 1,
                    Type: 1,
                    OrderType: this.orderType,
                    CustomerID: this.$store.state[APP_CONFIG.stateKey.authStore].userInfo.userId
                };
                const result = await commentServices.addComment(commentModel);
                this.comment = '';
                this.isBlockEnter = false;
                if (result.data.status === 200) {
                    this.loadComment();
                }
            }
        }

        private triggerFileInput() {
            const fileInput = this.$refs.fileInput as HTMLInputElement;
            fileInput.click();
        }

        private async onFileSelected(event: any) {
            const file = event.target.files[0];
            if (!file) {
                return;
            }

            // Check file type
            if (!file.type.startsWith('image/')) {
                alert('Vui lòng chọn file ảnh!');
                return;
            }

            // Check file size (max 5MB)
            if (file.size > 5 * 1024 * 1024) {
                alert('Kích thước ảnh không được vượt quá 5MB!');
                return;
            }

            if (this.isUploading) {
                return;
            }

            try {
                this.isUploading = true;
                const result: any = await fileUploadServices.uploadFile(file, 'chat');
                
                if (result && result.data && result.data.status === 200) {
                    const imageUrl = result.data.data.url;
                    
                    // Send comment with image
                    const commentModel: Comment = {
                        OrderID: this.orderId,
                        Comment: imageUrl,
                        Status: 1,
                        Type: 1,
                        OrderType: this.orderType,
                        CustomerID: this.$store.state[APP_CONFIG.stateKey.authStore].userInfo.userId,
                        Media: 1
                    };
                    
                    const commentResult = await commentServices.addComment(commentModel);
                    if (commentResult.data.status === 200) {
                        this.loadComment();
                    }
                } else {
                    alert('Upload ảnh thất bại!');
                }
            } catch (error) {
                alert('Có lỗi xảy ra khi upload ảnh!');
            } finally {
                this.isUploading = false;
                // Reset input
                const fileInput = this.$refs.fileInput as HTMLInputElement;
                fileInput.value = '';
            }
        }

        private openImage(imageUrl: string) {
            window.open(imageUrl, '_blank');
        }

        private setScroll() {
            setTimeout(() => {
                const boxMess: any = this.$el.querySelector('.content-message');
                boxMess.scrollTop = boxMess.scrollHeight;
            }, 0);
        }
    }
